import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Mail, Lock, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import { toast } from 'sonner';
import { getSafeRedirectPath } from '../utils/safeRedirect';

export default function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const safeNext = getSafeRedirectPath(searchParams.get('next'));
    const registerTo = safeNext ? `/register?next=${encodeURIComponent(safeNext)}` : '/register';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const result = await login(email, password);
        setLoading(false);
        if (result.success) {
            toast.success('Επιτυχής σύνδεση!');
            navigate(safeNext || '/account');
        } else {
            toast.error(result.error);
        }
    };

    return (
        <div className="min-h-screen bg-background flex flex-col">
            <Header />

            <main className="flex-1 flex items-center justify-center px-4">
                <div className="w-full max-w-sm space-y-6">
                    <div className="text-center">
                        <h1 className="font-display text-2xl font-semibold text-primary">Σύνδεση</h1>
                        <p className="text-sm text-muted-foreground mt-1">Συνδεθείτε στον λογαριασμό σας</p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-4" data-testid="customer-login-form">
                        <div className="relative">
                            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                            <Input
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="pl-10 h-11 rounded-xl"
                                required
                                data-testid="customer-email-input"
                            />
                        </div>
                        <div className="relative">
                            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                            <Input
                                type="password"
                                placeholder="Κωδικός"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="pl-10 h-11 rounded-xl"
                                required
                                data-testid="customer-password-input"
                            />
                        </div>
                        <Button 
                            type="submit" 
                            className="w-full h-11 rounded-xl" 
                            disabled={loading}
                            data-testid="customer-login-btn"
                        >
                            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
                            Σύνδεση
                        </Button>
                    </form>

                    <p className="text-center text-sm text-muted-foreground">
                        Δεν έχετε λογαριασμό;{' '}
                        <Link to={registerTo} className="text-primary font-medium hover:underline" data-testid="go-to-register">
                            Εγγραφή
                        </Link>
                    </p>
                    <p className="text-center">
                        <Link to="/" className="text-sm text-muted-foreground hover:text-foreground">
                            ← Επιστροφή στο κατάστημα
                        </Link>
                    </p>
                </div>
            </main>
        </div>
    );
}
